import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "menuButton"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.style.overflow = ""
  }

  openMenu() {
    this.element.classList.add("is-menu-open")
    this.menuButtonTarget.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
    this.sidebarTarget.querySelector("a, button")?.focus()
  }

  closeMenu() {
    this.element.classList.remove("is-menu-open")
    this.menuButtonTarget.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  closeDropdown(event) {
    event.currentTarget.closest(".dropdown")?.querySelector('[data-bs-toggle="dropdown"]')?.click()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.closeMenu()
  }
}
